import { AlignmentX } from '../../constants';

export const DRAWER_CLOSE_BUTTON_LABEL_DEFAULT = 'Close';

export const DRAWER_ALIGNMENT_DEFAULT = AlignmentX.RIGHT;
